import { createSlice } from "@reduxjs/toolkit";
import { resetPatientData } from "../../../system/store/reset.slice";

const initialState = {
  data: null,
};

export const encountersSlice = createSlice({
  name: "entities/patient-stats/encounters-slice",
  initialState,
  reducers: {
    setEncounters: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPatientData, () => initialState);
  },
});

export const { setEncounters } = encountersSlice.actions;

export default encountersSlice.reducer;
